// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2wdo_","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3zbNR","obliqueLine":"membershipbadge_obliqueLine__3gI3r"};